<wbo-search-page>
    <wbo-search-form>
        <wbo-search-form-fields>
            <wbo-search-form-field field="firstName">
                <wbo-simple-search-control></wbo-simple-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field field="lastName">
                <wbo-simple-search-control></wbo-simple-search-control>
            </wbo-search-form-field>
        </wbo-search-form-fields>
        <wbo-search-form-extended-fields>
            <wbo-search-form-field *extendedField="'startDateFrom'">
                <wbo-date-search-control></wbo-date-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field *extendedField="'startDateTo'">
                <wbo-date-search-control></wbo-date-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field *extendedField="'outletGroupId'">
                <wbo-location-multi-select-search-control></wbo-location-multi-select-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field *extendedField="'status'">
                <wbo-single-select-search-control initialDefaultValue="all">
                    <wbo-select-options>
                        <wbo-select-option value="all" label="wbo.shift.option.status.all">
                        </wbo-select-option>
                        <wbo-select-option value="signedin" label="wbo.shift.option.status.signedIn">
                        </wbo-select-option>
                        <wbo-select-option value="signedout" label="wbo.shift.option.status.signedOut">
                        </wbo-select-option>
                    </wbo-select-options>
                </wbo-single-select-search-control>
            </wbo-search-form-field>
        </wbo-search-form-extended-fields>
    </wbo-search-form>
    <wbo-search-grid>
        <wbo-main-search-column field="firstName"></wbo-main-search-column>
        <wbo-column field="lastName"></wbo-column>
        <wbo-date-column field="start"></wbo-date-column>
        <wbo-time-column field="startTime"></wbo-time-column>
        <wbo-date-column field="finish"></wbo-date-column>
        <wbo-time-column field="finishTime"></wbo-time-column>
        <wbo-column field="locationName"></wbo-column>
        <wbo-column field="verified"></wbo-column>
        <wbo-actions-search-column>
            <wbo-delete-search-action></wbo-delete-search-action>
        </wbo-actions-search-column>
    </wbo-search-grid>
</wbo-search-page>
